import moment from 'moment-timezone';

import { LifeCycle } from './lifeCycle';

interface Options {
  format?: string;
  showTimezone?: boolean;
}

const defaultOptions: Options = {
  format: 'DD MMM YYYY HH:mm',
  showTimezone: true,
};

export const getActiveDates = (cycle: LifeCycle, options?: Options): string => {
  options = {
    ...defaultOptions,
    ...options,
  };

  if (!cycle.startTime && !cycle.endTime) {
    return 'Always Running';
  }

  const dates = [];
  const offsets = [];

  if (cycle.startTime) {
    const m = moment(cycle.startTime);
    dates.push(`From ${m.format(options.format)}`);
    offsets.push(m.format('Z').split(':')[0]);
  }

  if (cycle.endTime) {
    const m = moment(cycle.endTime);
    dates.push(`Until ${m.format(options.format)}`);
    offsets.push(m.format('Z').split(':')[0]);
  }

  if (!options.showTimezone) {
    return dates.join(' ');
  }

  if (offsets.length === 1 || offsets[0] === offsets[1]) {
    return `${dates.join(' ')} (GMT${offsets[0]})`;
  }

  return `From ${dates[0]} (GMT${offsets[0]}) Until ${dates[1]} (GMT${offsets[1]})`;
};
